var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editType == "edit" ? "编辑" : "新增",
            visible: _vm.visible,
            "close-on-click-model": false,
            "append-to-body": "",
            width: `${900}px`,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.summaryDailogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-position": "right",
                model: _vm.formChild,
                rules: _vm.formRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "请选择月份", prop: "month" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "month",
                      disabled: _vm.editType === "edit",
                      "value-format": "yyyy-MM",
                      size: "small",
                      placeholder: "请选择月份",
                    },
                    on: { change: _vm.handeTimeChange },
                    model: {
                      value: _vm.formChild.month,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "month", $$v)
                      },
                      expression: "formChild.month",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "结算版本", prop: "version" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        size: "small",
                        disabled: _vm.editType === "edit",
                        clearable: "",
                        placeholder: "请选择结算版本",
                      },
                      model: {
                        value: _vm.formChild.version,
                        callback: function ($$v) {
                          _vm.$set(_vm.formChild, "version", $$v)
                        },
                        expression: "formChild.version",
                      },
                    },
                    _vm._l(_vm.versionOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "版本名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "520px" },
                    attrs: {
                      placeholder: "请输入简要说明，方便区分多次结算数据",
                    },
                    model: {
                      value: _vm.formChild.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "name", $$v)
                      },
                      expression: "formChild.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("提交")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "info",
                    icon: "el-icon-circle-close",
                  },
                  on: { click: _vm.summaryDailogClose },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }